import { useEffect, useState } from 'react';

import { JsonRpcSigner } from '@ethersproject/providers';

import { Erc20Controller } from '@bitcoin-portal/neko-web-sdk';

// used for farms and staking currently
// TODO: use for getContractDecimals + poolsTransactions?
export const useErc20Controller = (
  signer: JsonRpcSigner | undefined,
  contractId: string,
): Erc20Controller | undefined => {
  const [erc20Controller, setErc20Controller] = useState<Erc20Controller>();

  useEffect(() => {
    if (!signer) return;

    const controller = new Erc20Controller(signer, contractId);

    setErc20Controller(controller);
  }, [signer]);

  return erc20Controller;
};
